import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-button-loader',
    templateUrl: './button-loader.component.html',
    styleUrls: ['./button-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonLoaderComponent implements OnInit {
    @Input() isLoading = false;

    @Input() initialText: string;

    @Input() loadingText = '';

    @Input() classes: string;

    constructor() {}

    ngOnInit(): void {}
}
